// extracted by mini-css-extract-plugin
export default {"borderGrey":"#b5b4b5","zIndexModalBackdrop":"1040","theme--default":"theme--default","theme--dark":"theme--dark","app":"g8JiSsMOgshd60Da"};